import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BaseAuthGuard } from './base-auth.guard';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AuthAdminGuard extends BaseAuthGuard {

  constructor() {
    super();
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (await firstValueFrom(this.authService.isAuthenticated$) && this.authService.isAdmin()) {
      return true;
    }

    this.login(route);
    return false;
  }
}

